import React from "react";
import CText from "./CText";
import {  View, Image, TouchableOpacity, Text} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, } from "rn-responsive-styles";


export default function CCheckbox({textColor,textDecorationLine,setIsTermsChecked,isTermsChecked,termsText,termsText2,onPress,TermsAndCondition,backgroundColor}) {
    const styles = useStyles();
    
    const TncText = ()=>{
        return(
            <CText.headerDesc style={{ flexWrap: 'wrap',color:textColor ? textColor :"#212121", }}>
                {termsText} 
                <TouchableOpacity onPress={onPress}>
                 <Text style={{textDecorationLine:textDecorationLine?  textDecorationLine :"underline",fontWeight:"bold"}}>{TermsAndCondition}</Text>
                </TouchableOpacity>  {termsText2}
            </CText.headerDesc>
        )
    }
    return (
        <View style={styles.contentWrapper}>
            <TouchableOpacity onPress={() => { setIsTermsChecked(!isTermsChecked)}} style={[styles.radiobuttonOutSideStyle, { width: 15.9, height: 15.9, borderRadius: 3, borderColor: "#c3c3c3" }]} >
                {isTermsChecked ?
                    <View style={{ backgroundColor: backgroundColor ? backgroundColor : "#666666", width: 15.9, height: 15.9, borderRadius: 3, borderColor: "#c3c3c3", alignItems: "center" }}>
                        <Image source={require("./../assets/images/termsChecked.png")} style={{ width: 12, height: 12 }} />
                    </View> 
                    : null}
            </TouchableOpacity>
            <View style={{ paddingLeft: 10, width: '90%' }}>
                <TncText />
            </View>
        </View>
    )
}

const useStyles = CreateResponsiveStyle({
    contentWrapper: {
        flexDirection: 'row',
        marginTop: 10
    },
    radiobuttonOutSideStyle: {
        width: 15,
        height: 15,
        borderRadius: 10,
        borderColor: "#9d1d27",
        borderWidth: 2,
        alignItems: "center",
        justifyContent: "center",
        marginLeft: 10,
    },
},
    {
        [DEVICE_SIZES.LG]: {},
        [DEVICE_SIZES.MD]: {},
        [DEVICE_SIZES.SM]: {},
        [DEVICE_SIZES.XS]: {
            contentWrapper: {
                paddingLeft: 0
            },
        }
    }
)

